var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ims-button',{staticClass:"btn btn-icon ims-back-button",on:{"click":function($event){return _vm.back()}}},[_c('ims-icon',{staticClass:"mr-2",attrs:{"icon":"arrow_back"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }